import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/layout/Layout";
import AdminLayout from "@/components/layout/AdminLayout";

import Home from "@/pages/Home";
import Corsi from "@/pages/Corsi";
import CorsoDetail from "@/pages/CorsoDetail";
import SamaritaniSede from "@/pages/SamaritaniSede";
import Defibrillatore from "@/pages/Defibrillatore";
import ChiSiamo from "@/pages/ChiSiamo";
import Contatti from "@/pages/Contatti";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import RichiestaPreventivo from "@/pages/RichiestaPreventivo";
import IscrizioneConfermata from "@/pages/IscrizioneConfermata";
import Privacy from "@/pages/Privacy";
import Termini from "@/pages/Termini";
import Impressum from "@/pages/Impressum";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminBlogList from "@/pages/admin/AdminBlogList";
import AdminBlogEditor from "@/pages/admin/AdminBlogEditor";
import ProtectedRoute from "@/components/ProtectedRoute";
import Analytics from "@/components/Analytics";

function App() {
    return (
        <div className="App">
            <HelmetProvider>
                <BrowserRouter>
                <Analytics />
                <Routes>
                    {/* Public routes with main Layout */}
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/corsi" element={<Corsi />} />
                        <Route path="/corsi/bls-aed-aziende" element={<Navigate to="/corsi/bls-aed-src" replace />} />
                        <Route path="/corsi/primo-soccorso-patente" element={<Navigate to="/corsi/samaritani" replace />} />
                        <Route path="/corsi/cqc" element={<Navigate to="/corsi" replace />} />
                        <Route path="/corso-samaritani-bellinzona" element={<SamaritaniSede sede="bellinzona" />} />
                        <Route path="/corsi/:slug" element={<CorsoDetail />} />
                        <Route path="/defibrillatori-noleggio" element={<Defibrillatore />} />
                        <Route path="/defibrillatore" element={<Navigate to="/defibrillatori-noleggio" replace />} />
                        <Route path="/chi-siamo" element={<ChiSiamo />} />
                        <Route path="/contatti" element={<Contatti />} />
                        <Route path="/richiesta-preventivo" element={<RichiestaPreventivo />} />
                        <Route path="/iscrizione-confermata" element={<IscrizioneConfermata />} />
                        <Route path="/blog" element={<Blog />} />
                        <Route path="/blog/:slug" element={<BlogPost />} />
                        <Route path="/privacy-policy" element={<Privacy />} />
                        <Route path="/termini-e-condizioni" element={<Termini />} />
                        <Route path="/impressum" element={<Impressum />} />
                        <Route path="*" element={<NotFound />} />
                    </Route>

                    {/* Admin routes */}
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                        <Route path="/admin" element={<Navigate to="/admin/blog" replace />} />
                        <Route path="/admin/blog" element={<AdminBlogList />} />
                        <Route path="/admin/blog/new" element={<AdminBlogEditor />} />
                        <Route path="/admin/blog/:id" element={<AdminBlogEditor />} />
                    </Route>
                </Routes>
                <Toaster richColors position="top-center" />
            </BrowserRouter>
            </HelmetProvider>
        </div>
    );
}

export default App;
